import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { isDefined } from '@/utils/miscUtils';
import Select from '@/components/core/form/Select';
import usePatchParams from '../usePatchParams';

const AnnualChangeBeginning = ({ param, name, className, options = {}, selectOptions = [], disabled = false }) => {
  const { value, is_default: isDefault, default: defaultValue } = param ?? {};
  const { setValue } = useFormContext();

  const fieldName = `annual_change_beginning.${name}`;
  const { patchParam } = usePatchParams(options);

  const onChange = async e => {
    const value = e.target.value ? parseInt(e.target.value) : null;
    await patchParam(name, 'annual_change_beginning', value, fieldName);
  };

  useEffect(() => {
    if (isDefined(value)) {
      setValue(fieldName, value, { shouldValidate: true, shouldDirty: false });
    }
  }, [value, fieldName, setValue]);

  return (
    <Select
      name={fieldName}
      options={selectOptions}
      registerOptions={{ valueAsNumber: true }}
      defaultValue={defaultValue}
      className={`${className} ${!isDefault ? 'font-bold' : ''} select-sm`}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

AnnualChangeBeginning.propTypes = {
  param: PropTypes.object,
  label: PropTypes.string,
  paramSchema: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.object,
  selectOptions: PropTypes.array,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default AnnualChangeBeginning;
